import useReadQna from "../../hooks/useReadQna";
import moment from "moment";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PaginationMain } from "../../../../../components/common/pagination/PaginationMain";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import { useEditQna } from "../../hooks/useEditQna";
import { useUser } from "../../../../../util/userContext/UserContext";
import { useModal } from "../../../../../hooks";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

export default function SearchTable() {
    const { res } = useReadQna();
    const { data } = res;
    const { user } = useUser();
    const navigate = useNavigate();

    const [checkboxArr, setCheckboxArr] = useState<string[]>([]);
    const { deleteQna } = useEditQna();
    const { handleModal } = useModal();

    const isAllCheck = data?.qnaList?.length !== 0 && data?.qnaList?.map(el => el.qnaId).every(el => checkboxArr.includes(el));

    const clickAllCheck = () => {
        if (isAllCheck) {
            const list = checkboxArr.filter(el => !data?.qnaList.map(el => el.qnaId).includes(el))

            setCheckboxArr(list)
        } else {
            // @ts-ignore
            const list = [...new Set([...checkboxArr, ...data?.qnaList.map(el => el.qnaId)])]

            setCheckboxArr(list)
        }
    }

    const clickCheck = (el: any) => {
        if (checkboxArr.includes(el.qnaId)) {
            const list = checkboxArr.filter(el2 => el.qnaId !== el2)

            setCheckboxArr(list)
        } else {
            setCheckboxArr([...checkboxArr, el.qnaId])
        }
    }

    const questionStateColor = (state: string) => {
        switch (state) {
            case "진행":
                return "text-success";
            case "완료":
                return "text-light";
            case "활성":
                return "text-primary";
            case "비활성":
                return "text-secondary";
            default:
                return "";
        }
    }

    const rowClickEvent = (item: any) => {
        /**
         if(item.userId === user?.userId)
         navigate(`${process.env.PUBLIC_URL}/support/qna/detail/${item.qnaId}`);
         else
         handleModal({
         isOpen: true,
         type: 'alert',
         contents: '다른 요청자의 글은 읽을 수 없습니다.'
         });
         */
        navigate(`${process.env.PUBLIC_URL}/support/qna/detail/${item.qnaId}`);
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">1:1 문의 목록(<span>{data?.totalCount ?? 0}</span>건)</h6>
            <div className="table_toolbar">
                <AuthorityChecker authorityNames={['qnaReadYn', 'qnaWriteYn']}>
                    <button className="btn btn-dark w-100px"
                        onClick={() => navigate(`${process.env.PUBLIC_URL}/support/qna/create`)}>
                        추가
                    </button>
                </AuthorityChecker>
                <AuthorityChecker authorityNames={['qnaWriteYn']}>
                    <button
                        className="btn btn-outline-dark"
                        onClick={() => deleteQna({ qnaIdList: checkboxArr })}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />
                        선택삭제
                    </button>
                </AuthorityChecker>
            </div>
        </div>
        {/* 내부수정: table_scroll 삭제 */}
        <table className="table table-bordered my_table">
            <thead>
                <tr>
                    <AuthorityChecker authorityNames={['qnaWriteYn']}>
                        <th rowSpan={2} style={{ width: "3%" }}>
                            <div className="checkbox_outer">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isAllCheck}
                                    onClick={clickAllCheck} />
                            </div>
                        </th>
                    </AuthorityChecker>
                    <th style={{ width: "8%" }} rowSpan={2}>문의 일자</th>
                    <th style={{ width: "8%" }} rowSpan={2}>유형</th>
                    <th style={{ width: "24%" }} colSpan={3}>제품</th>
                    <th rowSpan={2}>제목</th>
                    <th style={{ width: "8%" }} rowSpan={2}>기술지원</th>
                    <th style={{ width: "16%" }} colSpan={2}>고객</th>
                    <th style={{ width: "8%" }} rowSpan={2}>상태</th>
                </tr>
                <tr>
                    <th style={{ width: "8%" }}>벤더</th>
                    <th style={{ width: "8%" }}>카테고리</th>
                    <th style={{ width: "8%" }}>제품군</th>
                    <th style={{ width: "8%" }}>고객사</th>
                    <th style={{ width: "8%" }}>요청자</th>
                </tr>
            </thead>
            <tbody>
                {(data?.qnaList ?? []).map((item) => (
                    <tr className={checkboxArr.includes(item.qnaId) ? "lightblue clickable" : "clickable"}
                        onClick={() => rowClickEvent(item)}>
                        <AuthorityChecker authorityNames={['qnaWriteYn']}>
                            <td className="text-center">
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={checkboxArr.includes(item.qnaId)}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            clickCheck(item)
                                        }}
                                    />
                                </div>
                            </td>
                        </AuthorityChecker>
                        <td className="text-center">{moment(item.regAt).format('YYYY.MM.DD')}</td>
                        <td className="text-center">{item.topicType}</td>
                        <td className="text-center">{item.productVendor}</td>
                        <td className="text-center">{item.productCategory}</td>
                        <td className="text-center">{item.newName}</td>
                        {/* 내부수정: 파일 첨부 
                        <td>{item.title}</td> */}
                        <td className="text-start">
                            <span>{item.title}</span>
                            {item.hasAttachment &&
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_attachment.png"}
                                    alt="첨부파일"
                                    style={{ width: "16px", marginLeft: "6px", verticalAlign: "middle" }}
                                />
                            }
                        </td>
                        <td className="text-center">{
                        item.technicalSupportUserName && item.technicalSupportUserName !== '미지원' ? 
                        item.technicalSupportUserName : 
                        item.technicalSupportUserName && item.technicalSupportUserName === '미지원' ? '배정 전' : '-'}</td>
                        <td className="text-center">{item.companyName}</td>
                        <td className="text-center">{item.userName}</td>
                        <td className={`text-center ${questionStateColor(item.questionState)}`}>{item.questionState}</td>
                    </tr>
                ))}
                {(data?.qnaList.length ?? 0) === 0 && <EmptyTableRow colSpan={11} />}
            </tbody>
        </table>

        <PaginationMain totalCount={data?.totalCount ?? 0} />
    </div>
}